export default __webpack_public_path__ + "static/media/thinkers.6a9343b6.svg";